module.exports = __webpack_public_path__ + "static/media/dollar_coin_h.0a67ca91.png";